import { workflowDrivenCacheSyncActionCreator } from '../../../workflow-config/utils/store.utils';

export const ABERRATIONS_ACTIONS = {
  'SET_RESULTS':'ABERRATIONS.SET_RESULTS',
  'INIT':'ABERRATIONS.INIT',
  'SET_FILTERED_RESULTS':'ABERRATIONS.SET_FILTERED_RESULTS',
  'SET_FILTERED_RESULTS_COUNT':'[Aberrations] Set filtered results count',
  'SET_LOADING':'ABERRATIONS.SET_LOADING',
  'SET_FILTER_QUERY':'ABERRATIONS.SET_FILTER_QUERY',
};

export const initActionCreator = workflowDrivenCacheSyncActionCreator(ABERRATIONS_ACTIONS.INIT);
export const setLoadingStatusActionCreator = workflowDrivenCacheSyncActionCreator(ABERRATIONS_ACTIONS.SET_LOADING);
export const setResultsActionCreator = workflowDrivenCacheSyncActionCreator(ABERRATIONS_ACTIONS.SET_RESULTS);
export const setFilteredResultsActionCreator = workflowDrivenCacheSyncActionCreator(ABERRATIONS_ACTIONS.SET_FILTERED_RESULTS);
export const setFilteredResultsCountActionCreator = workflowDrivenCacheSyncActionCreator(ABERRATIONS_ACTIONS.SET_FILTERED_RESULTS_COUNT);
export const setFilterQueryActionCreator = workflowDrivenCacheSyncActionCreator(ABERRATIONS_ACTIONS.SET_FILTER_QUERY);
		